__turbopack_context__.v({
  "button": "bookDemoButton-module-scss-module__Y1VbaW__button",
  "icon": "bookDemoButton-module-scss-module__Y1VbaW__icon",
  "iconOpen": "bookDemoButton-module-scss-module__Y1VbaW__iconOpen",
  "logInBtnSpinner": "bookDemoButton-module-scss-module__Y1VbaW__logInBtnSpinner",
  "logInBtnSpinnerWrapper": "bookDemoButton-module-scss-module__Y1VbaW__logInBtnSpinnerWrapper",
  "loginButton": "bookDemoButton-module-scss-module__Y1VbaW__loginButton",
  "menuArrow": "bookDemoButton-module-scss-module__Y1VbaW__menuArrow",
  "menuContent": "bookDemoButton-module-scss-module__Y1VbaW__menuContent",
  "menuWrapper": "bookDemoButton-module-scss-module__Y1VbaW__menuWrapper",
  "planTag": "bookDemoButton-module-scss-module__Y1VbaW__planTag",
  "userProfileFallbackContainer": "bookDemoButton-module-scss-module__Y1VbaW__userProfileFallbackContainer",
});
